/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Save_JobInputs */

const en_jobs_save_job = /** @type {(inputs: Jobs_Save_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Job`)
};

const de_jobs_save_job = /** @type {(inputs: Jobs_Save_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stelle speichern`)
};

const fr_jobs_save_job = /** @type {(inputs: Jobs_Save_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer l'emploi`)
};

const es_jobs_save_job = /** @type {(inputs: Jobs_Save_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar empleo`)
};

const it_jobs_save_job = /** @type {(inputs: Jobs_Save_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva lavoro`)
};

const nl_jobs_save_job = /** @type {(inputs: Jobs_Save_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baan opslaan`)
};

const pl_jobs_save_job = /** @type {(inputs: Jobs_Save_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapisz ofertę`)
};

const fi_jobs_save_job = /** @type {(inputs: Jobs_Save_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tallenna työpaikka`)
};

const da_jobs_save_job = /** @type {(inputs: Jobs_Save_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gem job`)
};

const sv_jobs_save_job = /** @type {(inputs: Jobs_Save_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spara jobb`)
};

/**
* | output |
* | --- |
* | "Save Job" |
*
* @param {Jobs_Save_JobInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_save_job = /** @type {((inputs?: Jobs_Save_JobInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Save_JobInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_save_job(inputs)
	if (locale === "fr") return fr_jobs_save_job(inputs)
	if (locale === "es") return es_jobs_save_job(inputs)
	if (locale === "it") return it_jobs_save_job(inputs)
	if (locale === "nl") return nl_jobs_save_job(inputs)
	if (locale === "pl") return pl_jobs_save_job(inputs)
	if (locale === "fi") return fi_jobs_save_job(inputs)
	if (locale === "da") return da_jobs_save_job(inputs)
	if (locale === "sv") return sv_jobs_save_job(inputs)
	return en_jobs_save_job(inputs)
});